module.exports = __webpack_public_path__ + "img/accounting-export.3af20768.svg";